import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';

import dynamicMiddlewares from "redux-dynamic-middlewares";
import {AppComponentState, appReducer} from "./AppReducer";
import {Dispatch, Middleware} from "redux";

import {EnhancedStore} from "@reduxjs/toolkit/src/configureStore";
import {appEpic} from "./AppEpics";
import {createEpicMiddleware, loggerMiddleware, PledgerAction, requestMiddleware} from "@pledger/frontend-commons";


const appEpicMiddleware = createEpicMiddleware<PledgerAction,PledgerAction,AppComponentState>();

export function initStore() {

  let result : EnhancedStore<AppComponentState, PledgerAction, Middleware<{}, any, Dispatch<PledgerAction>>[]>;

  // Listen for changes to the current location.
  if (process.env.NODE_ENV!=='production') {   // pas de log en production
    result = configureStore({
      reducer: appReducer,
      middleware: [appEpicMiddleware, requestMiddleware, loggerMiddleware, dynamicMiddlewares]
    });
  }
  else {
    result =  configureStore({
      reducer: appReducer,
      middleware: [appEpicMiddleware, requestMiddleware, dynamicMiddlewares]
    });
  }
  appEpicMiddleware.run(appEpic);
  return result;
}

export const store = initStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
